import React from "react";
import StrokeIcon from "./StrokeIcon";

const KEYS: Array<[number, number]> = [
  [6.2, 9.4], [9, 9.4], [11.8, 9.4],
  [6.2, 12], [9, 12], [11.8, 12],
  [6.2, 14.4], [9, 14.4], [11.8, 14.4],
];

/** Mulch Calculator: a calculator. Was the Products icon until 2026-10-01. */
export default function CalculatorIcon(props?: any) {
  return (
    <StrokeIcon iconProps={props}>
      {(color) => (
        <>
          <rect x="3.2" y="1.4" width="11.6" height="15.2" rx="1.6" />
          <rect x="5.4" y="3.6" width="7.2" height="3" />
          {KEYS.map(([cx, cy]) => (
            <circle key={`${cx}-${cy}`} cx={cx} cy={cy} r={0.8} fill={color} stroke="none" />
          ))}
        </>
      )}
    </StrokeIcon>
  );
}
